import { Container } from '@mantine/core';
// utils
import { cn } from '@/utils';
// assets
import styles from '@/components/Layout/components/PageContainer/PageContainer.module.css';

interface PageContainerProps {
    className?: string;
    children: React.ReactNode;
}

const PageContainer = ({ children, className }: PageContainerProps) => {
    return (
        <Container fluid className={cn(styles.container, className)}>
            {children}
        </Container>
    );
};

export default PageContainer;
